import { useLayoutEffect, useRef, useState } from "react";
import { createScrollCallback } from "../utils/createScrollCallback.js";
function useScrollbarApi(target) {
  const rTarget = useRef(target);
  useLayoutEffect(() => {
    rTarget.current = target;
  });
  const [api, setApi] = useState();
  useLayoutEffect(() => {
    const scrollTo = createScrollCallback("scrollTo", rTarget);
    const scrollBy = createScrollCallback("scrollBy", rTarget);
    setApi({
      scrollTo,
      scrollBy,
      getScrollbarRef: () => rTarget.current
    });
  }, []);
  return api;
}
export {
  useScrollbarApi
};
//# sourceMappingURL=useScrollbarApi.js.map
